<template>
  <div v-if="error.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in error" :key="index">{{ err }}</li>
    </ul>
  </div>

    <div class="cell small-12">
      <h1>Company Bank Account Details</h1>
      <p>To generate your payment file correctly, we need the details of the bank account you'll be using to make payroll and HMRC payments.</p>
      <p>These details will be included in the payment file as the source account from which the payments will be made.</p>
      </div>

    <div class="cell small-12">
    <BankAccount
        v-model:accountName="formData.bankAccount.accountName"
        v-model:accountNumber="formData.bankAccount.accountNumber"
        v-model:sortCode="formData.bankAccount.sortCode"
      />
    </div>

</template>


<script setup>

import { ref, onMounted } from 'vue'
import BankAccount from '@/components/BankAccount.vue'
import { useRoute } from 'vue-router';

const error = ref([]);
const route = useRoute();
const taskId = route.params.taskId;

const props = defineProps({
  formData: Object
})


const validateStep = () => {

  error.value = [];


  if (!props.formData.bankAccount.accountName) {
    error.value.push('Please provide the account name for your bank account.');
  }

  if (!props.formData.bankAccount.accountNumber) {
    error.value.push('Please provide the account number for your bank account.');
  } else if (!/^\d{8}$/.test(props.formData.bankAccount.accountNumber)) {
    error.value.push('The account number must be 8 digits.');
  }

  if (!props.formData.bankAccount.sortCode) {
    error.value.push('Please provide the sort code for your bank account.');
  } else if (!/^\d{2}-\d{2}-\d{2}$/.test(props.formData.bankAccount.sortCode)) {
    error.value.push('The sort code must be in the format XX-XX-XX.');
  }



  if (error.value.length > 0) return false;

  return true;
}



import { putDataCollectionTask } from '@/services/implementationmanagement.api';
const executeStep = async () => {

  var payload = {
    version: 1,
    dataJson: JSON.stringify(props.formData),
    schemaName: "OnlineBanking",
    taskId: taskId,
    taskStatus: "SuccessfullyCompleted"
  }

  var response = await putDataCollectionTask(taskId, payload);

  if (response.status !== 200) {
    error.value = 'Error saving data. Please contact your Qtac account manager.';
    return false;
  }


  
  return true;
}



onMounted(() => {

});

defineExpose({ validateStep, executeStep });

</script>